import Quill, { Parchment } from '@kim/quill';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EmbedCtor = Quill.import('blots/embed') as Parchment.BlotConstructor;

export interface ChipEmbedValue {
  type: 'select' | 'datetime';
  key: string;
  placeholder: string;
  options?: string[];
}

/**
 * ChipEmbed — 用于 select / datetime 类型的模板节点。
 * 在 Quill delta 中作为单字符 embed 存在，不可直接编辑；
 * 点击后由宿主组件弹出 antd Select / DatePicker。
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class ChipEmbed extends (EmbedCtor as any) {
  static blotName = 'chip-embed';
  static tagName = 'span';
  static className = 'chatbox-chip-embed';

  static create(value: ChipEmbedValue): HTMLElement {
    const node = super.create(value) as HTMLElement;
    node.setAttribute('contenteditable', 'false');
    node.dataset.chipType = value.type;
    node.dataset.chipKey = value.key;
    node.dataset.chipPlaceholder = value.placeholder;
    if (value.options) {
      node.dataset.chipOptions = JSON.stringify(value.options);
    }
    node.textContent = value.placeholder;
    return node;
  }

  static value(node: HTMLElement): ChipEmbedValue {
    return {
      type: (node.dataset.chipType ?? 'select') as 'select' | 'datetime',
      key: node.dataset.chipKey ?? '',
      placeholder: node.dataset.chipPlaceholder ?? '',
      options: node.dataset.chipOptions
        ? (JSON.parse(node.dataset.chipOptions) as string[])
        : undefined,
    };
  }
}
